const TEXT_FIELDS = ['businessDescription', 'productOrService', 'targetAudience', 'offer', 'toneOfVoice', 'visualStyle', 'websiteUrl'];

export function cleanSitePatch(raw) {
  const patch = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
  const out = {};
  TEXT_FIELDS.forEach((key) => {
    if (typeof patch[key] === 'string' && patch[key].trim()) out[key] = patch[key].trim().slice(0, 1000);
  });
  ['contentPillars', 'forbiddenTopics'].forEach((key) => {
    const items = Array.isArray(patch[key]) ? patch[key].map((value) => String(value || '').trim()).filter(Boolean) : [];
    if (items.length) out[key] = items.slice(0, 10);
  });
  if (patch.websiteAnalysis && typeof patch.websiteAnalysis === 'object' && !Array.isArray(patch.websiteAnalysis)) {
    out.websiteAnalysis = patch.websiteAnalysis;
  }
  return out;
}

export function websiteSourceMetadata(patch, confidence) {
  const now = new Date().toISOString();
  const safeConfidence = Number.isFinite(Number(confidence)) ? Number(confidence) : 0.74;
  return Object.keys(patch || {}).reduce((metadata, field) => {
    metadata[field] = { source: 'website', confidence: safeConfidence, needsReview: true, updatedAt: now };
    return metadata;
  }, {});
}

export function splitIntakeList(value) {
  return String(value || '').split(/[·,;\n]+/).map((item) => item.trim()).filter(Boolean).slice(0, 10);
}
